<template>
    <div class="self-goldcard-block">
        <div v-if="this.cardType === 'gold'" class="self-goldcard-block-hero">
            <img class="absolute top-0 left-0 w-full h-auto" src="../assets/static/images/kuldkaart.png"
                 alt="gold card">
        </div>

        <div v-else class="self-goldcard-block-hero">
            <img class="absolute top-0 left-0 w-full h-auto" src="../assets/static/images/platinum.png"
                 alt="platinum card">
        </div>

        <div class="p-24">
            <div v-if="this.cardType === 'gold'" class="self-body-text">
                <p>{{ $t('dashboard.bonus_card.collect') }}
                    <strong>{{ formatNumber(15000 - customerInfo.bp_collected).slice(0, -3) }}</strong>
                    {{ $t('dashboard.bonus_card.bp_to_platinum') }} <a
                        href="https://www.estravel.ee/platinum-club/">{{ $t('dashboard.bonus_card.platinum_level') }}</a>
                </p>
            </div>

            <div class="flex justify-between pt-24">
                <div>
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.bp') }}</label>
                    <span class="flex items-end">
                        <router-link
                            :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/bonuspoints`"
                            class="block text-lg font-semibold underline self-animate font-heading text-primary hover:text-blue-300"
                            href="bonuspoints">{{ customerInfo.bp_collected }}</router-link>
                    </span>
                </div>

                <div v-if="this.cardType === 'gold'" class="text-right">
                    <label class="text-gray-100 self-label-sm">{{ $t('dashboard.bonus_card.bp') }}</label>
                    <span class="block text-lg font-normal text-gray-100 font-heading">15 000</span>
                </div>
            </div>

            <div v-if="this.cardType === 'gold'" class="flex items-center justify-between w-full pt-4">
                <div class="flex-1">
                    <div class="relative block w-full h-8 overflow-hidden bg-white rounded-full">
                        <div class="self-goldcard-points" :style="{ width: (customerInfo.bp_collected / 15000) * 100 + '%' }"></div>
                    </div>
                </div>
                <div class="pl-16">
                    <img class="flex-shrink-0 block w-56 h-auto" src="../assets/static/images/platinum.png" alt="">
                </div>
            </div>

            <div class="pt-24">
                <div>
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.bp_balance') }}:</label>
                    <span class="block font-semibold text-black title-lg">{{ customerInfo.bp_valid }} <span
                        class="text-md">({{ formatSum(customerInfo.bp_valid / BP_VALID_COEFFICIENT) }})</span></span>
                </div>
                <div>
                    <label class="self-label-sm">{{ $t('dashboard.bonus_card.card_no') }}</label>
                    <span class="block font-semibold text-black title-lg">{{ cardInfo.customer_card_no }}</span>
                </div>
            </div>

            <div v-if="this.$device.mobile" class="pt-24">
                <div class="flex items-center">
                    <img class="flex-shrink-0 block w-24 h-24 mr-8" src="../assets/static/images/mtasku.png"
                         alt="mTasku">
                    <div class="self-body-text self-body-text--sm" v-html="$t('dashboard.bonus_card.mTasku')"></div>
                </div>
            </div>

<!--TODO: add to wallet functionality-->
            <div v-if="this.$device.ios || this.$device.android" class="pt-24">
                <div class="flex items-center -mx-6">
                    <a v-if="this.$device.ios" href="#"><img class="flex-shrink-0 block w-auto h-40 mx-6"
                                     src="../assets/static/images/apple-wallet.png" alt=""></a>

                    <a v-if="this.$device.android" href="#">
                        <googleWalletSVG class="flex-shrink-0 block w-auto h-40 mx-6"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import googleWalletSVG from '../assets/static/icons-src/google-wallet.svg'
import { ICustomer } from '@/domain/ICustomer'
import { Component, Vue, Watch } from 'vue-property-decorator'
import UtilsMixin from '@/scripts/utils'
// eslint-disable-next-line camelcase
import bp_config from "../../config/bpConfig";
@Component({
    components: {
        googleWalletSVG
    },
    mixins: [UtilsMixin]
})
export default class GoldCard extends Vue {
    private cardType = 'gold'
    // eslint-disable-next-line camelcase
    BP_VALID_COEFFICIENT = bp_config.BP_VALID_COEFFICIENT;
    get customerInfo (): ICustomer {
        return this.$store.getters.getCustomerInfo
    }

    get cardInfo () {
        const cards = this.customerInfo.customer_cards
        const goldCard = cards.find(card => card.card_type_name === 'Kuldkaart')
        const platinumCard = cards.find(card => card.card_type_name === 'Platinum Club')
        if (platinumCard !== undefined) {
            this.cardType = 'platinum'
            return platinumCard
        }
        return goldCard
    }

    // TODO: test if works?
    // Watch for changes in customerInfo.bp_collected
    @Watch('customerInfo.bp_collected')
    onBpCollectedChange(value: number, oldValue: number) {
        if (value >= 15000) {
            this.cardType = 'platinum'
        } else {
            this.cardType = 'gold'
        }
    }
}
</script>

<style scoped>

</style>
